import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';
import { red } from '@mui/material/colors';
import { LoadingButton } from '@mui/lab';

type Props = {
    show: boolean;
    cancel: () => void;
    confirm: ((arg1: unknown) => void) | (() => void);
    isLoading?: boolean;
    title: string;
    secondary?: React.ReactNode;
    submitClass?: string;
    className?: string;
};

function ConfirmDeleteModal({
    className = '',
    secondary = null,
    submitClass = '',
    show,
    title,
    cancel,
    isLoading = false,
    confirm,
}: Props) {
    const { t } = useTranslation();
    return (
        <Dialog open={show} className={className}>
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            {secondary && (
                <DialogContent>
                    <DialogContentText> {secondary} </DialogContentText>
                </DialogContent>
            )}
            <DialogActions>
                <Button onClick={cancel} disabled={isLoading}>
                    {t('common.cancel')}
                </Button>

                <LoadingButton
                    onClick={confirm}
                    style={{
                        background: red[900],
                    }}
                    variant="contained"
                    autoFocus
                    className={submitClass}
                    loading={isLoading}
                >
                    {t('common.delete')}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDeleteModal;
